import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { TeacherData, TeacherService } from '../../services/teacher.service';

import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-display-teacher',
  templateUrl: './display-teacher.component.html',
  styleUrls: ['./display-teacher.component.css']
})
export class DisplayTeacherComponent implements OnInit {
  id: string;
  form: FormGroup;

  assignmentsSelect: {value: string, name: string}[];
  assignments: string[] = [];
  assignment: string = '';

  teacher: any;
  teacherSub: Subscription;

  constructor(
    private service: TeacherService,
    private data: TeacherData,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute
  ) {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.createForm();
    let sub = this.service.getTeacher(this.id).subscribe((teacher) => {
      sub.unsubscribe();
      // console.log(teacher);
      let {name, family, birthdate, semester, assignments} = teacher;
      this.teacher = {name, family, birthdate, semester};
      this.form.setValue(this.teacher);
      this.assignments = assignments;
      // this.selectedIds = [prVntaRef.id];
    });
  }

  ngOnDestroy() {
    this.teacherSub.unsubscribe();
  }

  createForm() {
    this.form = this.fb.group({
      name: ['', Validators.required],
      family: ['', Validators.required],
      birthdate: ['', Validators.required],
      semester: [1, [Validators.required, Validators.min(1), Validators.max(12)]],
    });
  }


}